// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"01d0b031","491":"5dee0177","726":"ccb06c8d"}[chunkId] + ".chunk.css";
};